export default {
    speedOverride_correctedSpeed: 'Corrected Speed',
    speedOverride_lastUpdated: 'Last Updated',
};